var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item1_box"},[_c('iframe',{staticStyle:{"height":"800px"},attrs:{"width":"100%","src":`${_vm.crturl}`}}),_c('vipLogin',{ref:"vipbox"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }